import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { HttpService } from "../http.service";
import { SalaryScaleModel } from "../models/hiring/salaryScale.model";
import { ServiceBase } from "../servicebase";
import { SalaryRangeModel } from "services/models/hiring/salaryRange.model";
import { Response } from "services/models/response";

@Injectable()
export class SalaryScaleService extends ServiceBase<SalaryScaleModel> {
  constructor(http: HttpService) {
    super("salaryscale", http, environment.apiUrl);
  }

  createEntity(input: any): SalaryScaleModel {
    return SalaryScaleModel.create(input);
  }

  getAllActive(): Observable<SalaryScaleModel[]> {
    return this.getAll().pipe(
      map((res) => res.data.filter((x) => x.enable))
    );
  }

  getSalaryRanges(salaryScaleId: string): Observable<Response<SalaryRangeModel[]>> {
    return this.http.get(`${this.endpoint}/${salaryScaleId}/salary-ranges`).pipe(
      map((res) => {
        const response = new Response<SalaryRangeModel[]>();
        response.data = res.body.map(pp => SalaryRangeModel.create(pp) as SalaryRangeModel);
        response.count = res.headers.get("x-count");
        return response;
      })
    );
  }
}
